'use strict';
angular.module('createNoticeGroupModule', []).controller('createNoticeGroupCtrl', [
    '$scope',
    '$modalInstance',
    'params',
    'iwoNoticeService',
    'modalDialog',
    '$q',
    '$element',
    function(
        $scope,
        $modalInstance,
        params,
        iwoNoticeService,
        modalDialog,
        $q,
        $element
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                userSelectedList: [],
                searchWord: '',
                groupName: '',
                keywords: '',
                windowTitle: '新建分组'
            };
            $scope.status = {
                isShowUserSearch: false
            };
        }

        /**
         * [initData 初始化编辑数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if (params && params.LABELORGANIZATIONID) {
                $scope.data.windowTitle = '编辑分组';
                var userIds = [], userNames = [];
                if (params.LABELNAME) {
                    $scope.data.groupName = params.LABELNAME;
                }
                if (params.USERIDS) {
                    userIds = params.USERIDS.split(',');
                }
                if (params.USERTRUNNAMES) {
                    userNames = params.USERTRUNNAMES.split(',');
                }
                if (userNames.length) {
                    for (let i = 0; i < userNames.length; i++) {
                        $scope.data.userSelectedList.push({
                            ID: userIds[i],
                            USERNAME: userNames[i]
                        });
                    }
                } 
            }
        }

        $scope.searchUser = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) { 
                $scope.data.searchWord = $scope.data.keywords;
            }
        };

        $scope.close = function() {
            $modalInstance.dismiss();
        };
        $scope.submit = function() {
            let data = {
                selectedArray: $scope.data.userSelectedList,
                groupName: $scope.data.groupName
            };
            if (params && params.LABELORGANIZATIONID) {
                editGroup(data).then(() => {
                    $modalInstance.close();
                });
            } else {
                addGroup(data).then(() => {
                    $modalInstance.close();
                });
            }
        };

        /**
         * [addGroup 新增分组]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function addGroup(data) {
            let defer = $q.defer();
            let params = {
                labelName: data.groupName,
                userIds: data.selectedArray.map((item) => item.ID).join(','),
                trueNames: data.selectedArray.map((item) => item.USERNAME).join(',')
            };
            $scope.loadingPromise = iwoNoticeService.addGroup(params).then((result) => {
                if (result.ISSUCCESS === 'true') {
                    modalDialog.alertType('', result.OPERATIONRESULT, 'success', false);
                    defer.resolve();
                } else {
                    defer.reject();
                }
            }, () => {
                defer.reject();
            });
            return defer.promise;
        }

        /**
         * [editGroup 编辑分组]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function editGroup(data) {
            let defer = $q.defer();
            let userIds = data.selectedArray.map((item) => item.ID).join(',');
            let trueNames = data.selectedArray.map((item) => item.USERNAME).join(',');
            let editParams = {
                labelName: data.groupName !== params.LABELNAME ? data.groupName : undefined,
                userIds: userIds,
                trueNames: trueNames,
                labelOrganizationId: params.LABELORGANIZATIONID,
            };
            $scope.loadingPromise = iwoNoticeService.editGroup(editParams).then((result) => {
                if (result.ISSUCCESS === 'true') {
                    modalDialog.alertType('', result.OPERATIONRESULT, 'success', false);
                    defer.resolve();
                } else {
                    defer.reject();
                }
            }, () => {
                defer.reject();
            });
            return defer.promise;
        }
    },
]);
